export const SET_SIDEBAR_VISIBILITY = 'SET_SIDEBAR_VISIBILITY';

export const FETCH_ROUTE_PROGRESS = 'FETCH_ROUTE_PROGRESS';
export const FETCH_ROUTE_SUCCESS = 'FETCH_ROUTE_SUCCESS';
export const FETCH_ROUTE_FAILED = 'FETCH_ROUTE_FAILED';

export const FETCH_START_SUGGESTIONS = 'FETCH_START_SUGGESTIONS';
export const FETCH_DESTINATION_SUGGESTIONS = 'FETCH_DESTINATION_SUGGESTIONS';
export const SET_START = 'SET_START';
export const SET_DESTINATION = 'SET_DESTINATION';
export const SELECT_ROUTE = 'SELECT_ROUTE';
export const CLEAN_START = 'CLEAN_START';
export const CLEAN_DESTINATION = 'CLEAN_DESTINATION';
export const START_START_SEARCH = 'START_START_SEARCH';
export const START_DESTINATION_SEARCH = 'START_DESTINATION_SEARCH';
export const FINISH_START_SEARCH = 'FINISH_START_SEARCH';
export const FINISH_DESTINATION_SEARCH = 'FINISH_DESINTATION_SEARCH';

//  types for booking, payment and confirmation
export const CHANGE_SCREEN = 'CHANGE_SCREEN';
export const CLOSE_SCREENS = 'CLOSE_SCREENS';
export const OPEN_SCREENS = 'OPEN_SCREENS';

export const OPEN_PARKING_LOT_POPUP = 'OPEN_PARKING_LOT_POPUP';
export const CLOSE_PARKING_LOT_POPUP = 'CLOSE_PARKING_LOT_POPUP';

export const SET_DATE_TIME = 'SET_DATE_TIME';
export const SWAP_LOCATIONS = 'SWAP_LOCATIONS';
export const ALTERNATE_START = 'ALTERNATE_START';
export const ALTERNATE_DESTINATION = 'ALTERNATE_DESTINATION';